var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "authWrapper new-login-wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row whiteBG-wrap login-white-wrap"
  }, [_c('div', {
    staticClass: "col-lg-7 col-md-7 no-padding"
  }, [_c('div', {
    staticClass: "login-left-wrap"
  }, [_c('button', {
    staticClass: "text-link",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v(" Back")]), _vm._m(0), _c('h4', {
    staticClass: "login-title mb-2"
  }, [_vm._v("Verify it's you")]), _c('form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments);
      }
    }
  }, [_c('input-form-text', {
    attrs: {
      "rules": {
        required: true,
        email: true
      },
      "customMessages": `Please enter your email address.`,
      "customEmailMessage": `Please enter a valid email address`,
      "labelFor": "Email",
      "labelName": "Email",
      "inputName": "email",
      "formGroupClass": "form-group mb-3",
      "placeholder": "Please enter your email address",
      "isErrorFlagSet": _vm.emailErrorFlag,
      "vmodel": _vm.form.email,
      "disabled": true
    },
    on: {
      "emitChanges": _vm.resetErrorMsg,
      "update:vmodel": function ($event) {
        return _vm.$set(_vm.form, "email", $event);
      }
    }
  }), _c('input-form-text', {
    attrs: {
      "rules": {
        required: true
      },
      "customMessages": `Please enter your phone number.`,
      "labelFor": "Phone",
      "labelName": "Phone",
      "inputName": "phone",
      "formGroupClass": "form-group mb-3",
      "placeholder": "Please enter your phone number",
      "isErrorFlagSet": _vm.phoneErrorFlag,
      "vmodel": _vm.form.phone,
      "disabled": true
    },
    on: {
      "emitChanges": _vm.resetErrorMsg,
      "update:vmodel": function ($event) {
        return _vm.$set(_vm.form, "phone", $event);
      }
    }
  }), _c('div', {
    staticClass: "submit-btn-wrap"
  }, [_c('button', {
    staticClass: "submit-btn mt-1 next-btn w-100 ml-0",
    attrs: {
      "disabled": _vm.formLoader,
      "type": "button"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm.formLoader ? _c('b-spinner', {
    staticClass: "mr-3",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" Send Verification ")], 1)])], 1)])]), _c('div', {
    staticClass: "col-lg-5 col-md-5 no-padding p-0"
  }, [_c('Logincarsoule')], 1)])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "rep-icon-login"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/member-login.svg"),
      "alt": "image-fluid"
    }
  })]);

}]

export { render, staticRenderFns }